/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostCompanyUserReadNotificationsResponse
 */
export interface PostCompanyUserReadNotificationsResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof PostCompanyUserReadNotificationsResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof PostCompanyUserReadNotificationsResponse
     */
    message: string;
}

/**
 * Check if a given object implements the PostCompanyUserReadNotificationsResponse interface.
 */
export function instanceOfPostCompanyUserReadNotificationsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function PostCompanyUserReadNotificationsResponseFromJSON(json: any): PostCompanyUserReadNotificationsResponse {
    return PostCompanyUserReadNotificationsResponseFromJSONTyped(json, false);
}

export function PostCompanyUserReadNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCompanyUserReadNotificationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function PostCompanyUserReadNotificationsResponseToJSON(value?: PostCompanyUserReadNotificationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

